<div class="page-wrapper">
  <div class="infos-part">
    <div class="event-infos-wrapper">
      <div class="to-plan-wrapper"></div>
      <div class="event-infos">
        <div class="to-plan checkbox-wrapper" *ngIf="!readOnly">
          <label class="checkbox">
            <input *ngIf="formGroup" [formGroup]="formGroup" [formControl]="formGroup.get('toPlan')" (change)="toPLanChange($event.target.checked)" type="checkbox">
            <span class="checkMark"></span>
          </label>
          <div class="label">À planifier</div>
        </div>

        <frg-form-input *ngIf="formGroup" id="type" label="Type de rendez-vous" [selectValue]="eventTypesLabel"
          type="text" [formGroup]="formGroup" [control]="formGroup.get('type')" (modelChanged)="typeChange($event)" [disabled]="readOnly"></frg-form-input>

        <div class="date-wrapper"
          *ngIf="formGroup && (!formGroup.get('toPlan') || formGroup.get('toPlan').value === false)">
          <div class="picker-wrapper" [ngClass]="{ 'highlight': isDateTimeHighlighted }" *ngIf="formGroup">
            <div class="picker-label">Date</div>
            <div class="date-picker">
              <mat-form-field appearance="fill">
                <input #date matInput [disabled]="readOnly" [matDatepicker]="dateStartPicker" placeholder="JJ/MM/YYYY" [formControl]="formGroup.get('dateStart')" rInputMask="99/99/9999">
                <mat-datepicker-toggle matSuffix [for]="dateStartPicker"></mat-datepicker-toggle>
                <mat-datepicker #dateStartPicker></mat-datepicker>
              </mat-form-field>
            </div>
          </div>

          <!-- <div class="picker-wrapper" [ngClass]="{ 'highlight': isDateTimeHighlighted }">
            <div class="picker-label">Date de fin</div>
            <div class="date-picker">
              <mat-form-field appearance="fill">
                <input matInput [matDatepicker]="dateEndPicker" [formControl]="formGroup.get('dateEnd')"  rInputMask="99/99/9999">
                <mat-datepicker-toggle matSuffix [for]="dateEndPicker"></mat-datepicker-toggle>
                <mat-datepicker #dateEndPicker></mat-datepicker>
              </mat-form-field>
            </div>
          </div> -->
          <span>
            <div class="date-wrapper"
              *ngIf="formGroup && (!formGroup.get('toPlan') || formGroup.get('toPlan').value === false)">
              <div class="picker-wrapper" [ngClass]="{ 'highlight': isDateTimeHighlighted }">
                <div class="picker-label">Heure de début</div>
                <ngx-timepicker-field
                  #timepickerHourStart
                  id="timepickerHourStart"
                  [disabled]="readOnly"
                  [format]="24"
                  [defaultTime]="formGroup.get('hourStart').value"
                  [cancelBtnTmpl]="cancelBtn"
                  [confirmBtnTmpl]="confirmBtn"
                  [clockTheme]="customTimePickerTheme"
                  [toggleIcon]="icon"
                ></ngx-timepicker-field>
                <!-- <ngx-timepicker-field [disabled]="readOnly" (timeChanged)="timeChanged($event, 'hourStart')"
                  [defaultTime]="formGroup.get('hourStart').value" [format]="24" [cancelBtnTmpl]="cancelBtn"
                  [confirmBtnTmpl]="confirmBtn" [clockTheme]="customTimePickerTheme" [toggleIcon]="icon"
                  [min]="dayStartHour" [max]="dayEndHour">
                </ngx-timepicker-field> -->
              </div>
              <div class="picker-wrapper" [ngClass]="{ 'highlight': isDateTimeHighlighted }">
                <div class="picker-label">Heure de fin</div>
                <ngx-timepicker-field
                  #timepickerHourEnd
                  id="timepickerHourEnd"
                  [disabled]="readOnly"
                  [format]="24"
                  [defaultTime]="formGroup.get('hourEnd').value"
                  [cancelBtnTmpl]="cancelBtn"
                  [confirmBtnTmpl]="confirmBtn"
                  [clockTheme]="customTimePickerTheme"
                  [toggleIcon]="icon"
                ></ngx-timepicker-field>
                <!-- <ngx-timepicker-field #timeEnd  [disabled]="readOnly" (timeChanged)="timeChanged($event, 'hourEnd')"
                  [defaultTime]="formGroup.get('hourEnd').value" [format]="24" [cancelBtnTmpl]="cancelBtn"
                  [confirmBtnTmpl]="confirmBtn" [clockTheme]="customTimePickerTheme" [toggleIcon]="icon"
                  [min]="dayStartHour" [max]="dayEndHour">
                </ngx-timepicker-field> -->
              </div>
            </div>
          </span>
        </div>


        <ng-template #cancelBtn>
          <div class="custom-btn">Annuler</div>
        </ng-template>
        <ng-template #confirmBtn>
          <div class="custom-btn">OK</div>
        </ng-template>
        <ng-template #icon>
          <svg width="16" height="16" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M11 22C4.92487 22 0 17.0751 0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22ZM11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20ZM16 10H12V5H10V12H16V10Z"
              fill="#a9b5c1" />
          </svg>
        </ng-template>

        <frg-form-input
          *ngIf="formGroup"
          id="resource"
          label="Ressources"
          [selectValue]="resourcesLabel"
          type="ngSelect"
          isMultiSelect="true"
          [formGroup]="formGroup"
          [control]="formGroup.get('resource')"
        ></frg-form-input>

        <!-- TODO A REACTIVER PLUS TARD SI BESOIN -->
        <!-- <div *ngIf="formGroup && (!formGroup.get('toPlan') || formGroup.get('toPlan').value === false)"
          class="reccurrence-wrapper">
          <div class="label">Récurrence</div>
          <div class="recurrence-values">
            <div class="recurrence-value">{{ formGroup.get('recurrence').value }}</div>
            <div class="icon" *ngIf="!readOnly" (click)="openEditRecurrence()">
              <span class="update-icon"></span>
            </div>
            <div class="icon" (click)="removeRecurrence()" *ngIf="!readOnly && eventRecurrence && (!initialEvent || !initialEvent.recurrence)">
              <span class="delete-icon"></span>
            </div>
          </div>
        </div> -->

        <frg-form-input *ngIf="!readOnly && (formGroup && (!formGroup.get('toPlan') || formGroup.get('toPlan').value === false))"
          id="hourSplit" label="Diviser la plage horaire" [selectValue]="hourSplitLabel" type="text"
          [formGroup]="formGroup" [control]="formGroup.get('hourSplit')"></frg-form-input>
      </div>
      <div class="reminder-wrapper">
        <div class="do-remind checkbox-wrapper">
          <label class="checkbox">
            <input *ngIf="formGroup" [attr.disabled]="readOnly ? true : null" [formGroup]="formGroup" [formControl]="formGroup.get('reminder')" type="checkbox">
            <span class="checkMark"></span>
          </label>
          <div class="label">Activer les rappels rendez-vous</div>
        </div>
        <!-- TODO START : Ces champs sont cachés tant que le client n'a pas de service d'envoi de SMS (ce qui fait l'envoie de mail l'option par défaut) -->
        <!-- <div class="remind-sms checkbox-wrapper"
          *ngIf="formGroup && formGroup.get('reminder') && formGroup.get('reminder').value === true">
          <label class="checkbox">
            <input *ngIf="formGroup" [attr.disabled]="readOnly ? true : null" [formGroup]="formGroup" [formControl]="formGroup.get('reminderSMS')"
              type="checkbox">
            <span class="checkMark"></span>
          </label>
          <div class="label">Envoyer le rappel par SMS</div>
        </div>
        <div class="remind-mail checkbox-wrapper"
          *ngIf="formGroup && formGroup.get('reminder') && formGroup.get('reminder').value === true">
          <label class="checkbox">
            <input *ngIf="formGroup" [attr.disabled]="readOnly ? true : null" [formGroup]="formGroup" [formControl]="formGroup.get('reminderMail')"
              type="checkbox">
            <span class="checkMark"></span>
          </label>
          <div class="label">Envoyer le rappel par Mail</div>
        </div> -->
        <!-- TODO END -->
        <div class="remind-mail checkbox-wrapper"
          *ngIf="formGroup && formGroup.get('reminder') && formGroup.get('reminder').value === true">
          <label class="checkbox">
            <input *ngIf="formGroup" [attr.disabled]="readOnly ? true : null" [formGroup]="formGroup" [formControl]="formGroup.get('reminderConfirmation')"
              type="checkbox">
            <span class="checkMark"></span>
          </label>
          <div class="label">Confirmation de rendez-vous</div>
        </div>
        <div class="remind-params-wrapper"
          *ngIf="formGroup && formGroup.get('reminder') && formGroup.get('reminder').value === true">
          <div class="remind-params-label">Date et heure des rappels</div>
          <div class="remind-params">
            <div class="remind-label">Pour le patient</div>
            <div class="remind-values">
              Nombre de jours
              <input [attr.disabled]="readOnly ? true : null" *ngIf="formGroup" type="number" [formGroup]="formGroup"
                [formControl]="formGroup.get('patientReminderDays')" min="0">
              et de minutes
              <input [attr.disabled]="readOnly ? true : null" *ngIf="formGroup" type="number" [formGroup]="formGroup"
                [formControl]="formGroup.get('patientReminderMinutes')" min="0">
              avant le rendez-vous
            </div>
          </div>
          <div class="remind-params">
            <div class="remind-label">pour le(s) médecin(s)</div>
            <div class="remind-values">
              Nombre de jours
              <input *ngIf="formGroup" [attr.disabled]="readOnly ? true : null" type="number" [formGroup]="formGroup"
                [formControl]="formGroup.get('practitionerReminderDays')" min="0">
              et de minutes
              <input *ngIf="formGroup" [attr.disabled]="readOnly ? true : null" type="number" [formGroup]="formGroup"
                [formControl]="formGroup.get('practitionerReminderMinutes')" min="0">
              avant le rendez-vous
            </div>
          </div>
        </div>
      </div>

      <div class="description">
        <div class="label">Description</div>
        <div class="text-zone">
          <textarea [attr.disabled]="readOnly ? true : null" rows="5" [placeholder]="textAreaPlaceholder" *ngIf="formGroup" [formGroup]="formGroup"
            [formControl]="formGroup.get('description')"></textarea>
        </div>
      </div>

      <div class="infos-complementaires" *ngIf="initialEvent && (initialEvent.enSalleDAttente || initialEvent.vuParMedecin)">
        <div class="label">Informations complémentaires</div>
        <div class="info-complementaire" *ngIf="initialEvent && initialEvent.enSalleDAttente">Arrivé en salle d'attente
          : {{ initialEvent.enSalleDAttente | date:"dd/MM/yyyy" }} à {{ initialEvent.enSalleDAttente | date:"HH:mm" }}
        </div>
        <div class="info-complementaire" *ngIf="initialEvent && initialEvent.vuParMedecin">Vu par le médecin : {{
          initialEvent.vuParMedecin | date:"dd/MM/yyyy" }} à {{ initialEvent.vuParMedecin | date:"HH:mm" }}</div>
      </div>
    </div>

    <div class="event-patient-wrapper">
      <div class="search-bar" *ngIf="!readOnly">
        <input *ngIf="formGroup" [formGroup]="inputSearchForm" [formControl]="inputSearchForm.get('searchInput')"
          placeholder="Rechercher un patient" type="text">
        <!-- <div class="add-patient-button" (click)="createPatient()">
          <span class="add-patient-icon"></span>
        </div> -->
      </div>

      <div class="event-patient-content">

        <div *ngIf="readOnly && !initialEvent.patient">
          Aucun patient rattaché à ce rendez-vous.
        </div>

        <div class="searching-loader" [ngClass]="{ 'loading': isSearching }">
          <div class="lds-spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>

        <div class="no-result" [ngClass]="{ 'visible': searchingMessage }">
          Aucun patient trouvé
          <br>
          <br>
          Vous pouvez créer un patient en cliquant sur le bouton à droite de la barre de recherche.
        </div>

        <div *ngIf="patientSearchList.length > 0" class="patient-find-list">
          <div class="patient-item" *ngFor="let patient of patientSearchList" (click)="selectPatient(patient.id)">
            <div class="patient-item-name">{{ patient.nomPrenom }}</div>
            <div class="patient-item-birth">({{ patient.dateNaissance }})</div>
          </div>
        </div>

        <div
          *ngIf="patientSearchList.length === 0 && (!initialEvent || !initialEvent.patient) && createPatientFormGroup"
          class="create-patient">
          <div class="create-patient-infos">
            <frg-form-input label="Nom" id="nom" type="text" placeholder="Ex: Dupont"
              [formGroup]="createPatientFormGroup" [control]="createPatientFormGroup.get('nom')" required="true"
              class="patient-form-input" (keyup)="doUppercaseInputValue(createPatientFormGroup.get('nom'))">
            </frg-form-input>
            <frg-form-input label="Prénom" id="prenom" type="text" placeholder="Ex: Jean"
              [formGroup]="createPatientFormGroup" [control]="createPatientFormGroup.get('prenom')" required="true"
              class="patient-form-input" (keyup)="doUppercaseFirstLetterInputValue(createPatientFormGroup.get('prenom'))">
            </frg-form-input>
            <frg-form-input label="Date de naissance" id="dateNaissance" type="date" placeholder="JJ/MM/AAAA"
              [formGroup]="createPatientFormGroup" [control]="createPatientFormGroup.get('dateDeNaissance')"
              class="patient-form-input" required="true" [minDate]="patientBirthMin" [maxDate]="patientBirthMax">
            </frg-form-input>
            <frg-form-input
              label="Géré par"
              id="responsable"
              type="ngSelect"
              [selectValue]="profilResources"
              [formGroup]="createPatientFormGroup"
              [control]="createPatientFormGroup.get('responsable')"
              required="true"
              [isClearableSelect]="false"
              class="patient-form-input">
            </frg-form-input>
            <div class="create-patient-button-wrapper">
              <frg-button (activated)="doCreatePatient()" [disabled]="!createPatientFormGroup.valid">Sauvegarder
              </frg-button>
            </div>
          </div>
        </div>

        <div *ngIf="patientSearchList.length === 0 && (!initialEvent || !initialEvent.patient) && !createPatientFormGroup">
          <div class="buttons-wrapper inner-button" *ngIf="!readOnly">
            <frg-button (activated)="getLastPatient()">Patient en cours</frg-button>
          </div>
        </div>

        <div
          *ngIf="patientSearchList.length === 0 && initialEvent && initialEvent.patient && patientFormGroup && !searchingMessage && !createPatientFormGroup"
          class="patient-infos">

          <div class="redirect-patient-dossier" (click)="redirectToDossierPatient(initialEvent.patient.id)">
            <div class="redirect-icon"></div>
          </div>
          <div class="patient-visuel-container">
            <div class="patient-visuel">
              {{patientFormGroup.get('nom').value.slice(0,1)}}{{patientFormGroup.get('prenom').value.slice(0,1)}}
            </div>
          </div>
          <div class="patient-name">{{ patientFormGroup.get('nom').value }} {{ patientFormGroup.get('prenom').value }}
          </div>
          <div class="patient-birth">{{ patientFormGroup.get('dateNaissance').value }}</div>

          <div class="select-patient-infos">
            <div class="select-infos" [ngClass]="{ 'selected': displayContactInfos }" (click)="selectContactInfos()">
              Adresse principale</div>
            <div class="select-infos" [ngClass]="{ 'selected': !displayContactInfos }"
              (click)="selectConsultationsInfos()">Historique des rendez-vous</div>
          </div>

          <div *ngIf="initialEvent && initialEvent.patient && displayContactInfos" class="patient-contact-display">
            <ng-container *ngIf="editPatient">
              <div class="info-contact">
                <frg-form-input [disabled]="readOnly" *ngIf="patientFormGroup" label="Téléphone" id="tel" type="text"
                  [formGroup]="patientFormGroup" [control]="patientFormGroup.get('patientPhone')"
                  class="patient-form-input"></frg-form-input>
              </div>
              <div class="info-contact">
                <frg-form-input [disabled]="readOnly" *ngIf="patientFormGroup" label="Adresse" id="nom" type="text"
                  [formGroup]="patientFormGroup" [control]="patientFormGroup.get('patientAddress')"
                  class="patient-form-input"></frg-form-input>
                <frg-form-input [disabled]="readOnly" *ngIf="patientFormGroup" label="Code postal" id="prenom" type="text"
                  [formGroup]="patientFormGroup" [control]="patientFormGroup.get('patientZip')"
                  class="patient-form-input"></frg-form-input>
                <frg-form-input [disabled]="readOnly" *ngIf="patientFormGroup" label="Ville" id="ddn" type="text" [formGroup]="patientFormGroup"
                  [control]="patientFormGroup.get('patientCity')" class="patient-form-input"></frg-form-input>
              </div>
              <div class="info-contact">
                <frg-form-input [disabled]="readOnly" *ngIf="patientFormGroup" label="Mail" id="mail" type="text" [formGroup]="patientFormGroup"
                  [control]="patientFormGroup.get('patientMail')" class="patient-form-input"></frg-form-input>
              </div>
            </ng-container>
            <ng-contaienr *ngIf="!editPatient">
              <div class="patient-no-edit-line">
                Téléphone : <span>{{ patientFormGroup.get('patientPhone') && patientFormGroup.get('patientPhone').value && patientFormGroup.get('patientPhone').value !== '' ? patientFormGroup.get('patientPhone').value : '--'  }}</span>
              </div>
              <div class="patient-no-edit-line">
                Adresse : <span>{{ patientFormGroup.get('patientAddress') && patientFormGroup.get('patientAddress').value && patientFormGroup.get('patientAddress').value !== '' ? patientFormGroup.get('patientAddress').value : '--'  }}</span>
              </div>
              <div class="patient-no-edit-line">
                Code postal : <span>{{ patientFormGroup.get('patientZip') && patientFormGroup.get('patientZip').value && patientFormGroup.get('patientZip').value !== '' ? patientFormGroup.get('patientZip').value : '--'  }}</span>
              </div>
              <div class="patient-no-edit-line">
                Ville : <span>{{ patientFormGroup.get('patientCity') && patientFormGroup.get('patientCity').value && patientFormGroup.get('patientCity').value !== '' ? patientFormGroup.get('patientCity').value : '--'  }}</span>
              </div>
              <div class="patient-no-edit-line">
                Mail : <span>{{ patientFormGroup.get('patientMail') && patientFormGroup.get('patientMail').value && patientFormGroup.get('patientMail').value !== '' ? patientFormGroup.get('patientMail').value : '--'  }}</span>
              </div>
            </ng-contaienr>
            <div class="patient-button-wrapper" *ngIf="!readOnly">
              <frg-button *ngIf="editPatient && !readOnly" (activated)="cancelModifPatient()" [backgroundColor]="'var(--darkest-primary)'">Annuler</frg-button>
              <frg-button *ngIf="editPatient && !readOnly" (activated)="doUpdateAdressePatient()" [disabled]="!patientFormGroup.valid">Enregistrer</frg-button>
              <frg-button *ngIf="!editPatient && !readOnly" (activated)="doEditPatient()" [backgroundColor]="'var(--darkest-primary)'">Éditer</frg-button>
            </div>
          </div>
          <div *ngIf="initialEvent && initialEvent.patient && !displayContactInfos"
            class="patient-consultations-display">
            <div class="consultations-list"
              *ngIf="initialEvent.patient && patientEvents && patientEvents.objects.length > 0">
              <frg-table [keysBody]="patientEvents" [keysColumn]="patientEventsColumnTable"
                (onChangePage)="onChangePage($event)"></frg-table>
            </div>
            <div class="no-result" [ngClass]="{ 'visible': initialEvent && patientEvents.objects.length === 0 }">Aucun
              rendez-vous à afficher</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="initialEvent && initialEvent.createdBy && initialEvent.createdBy.nom" class="creator-wrapper">
    <div>Créé par <span>{{ initialEvent.createdBy.nom }}</span></div>
  </div>
  <div class="buttons-wrapper" *ngIf="!readOnly">
    <frg-button *ngIf="initialEvent && initialEvent.id && initialEvent.id !== ''" (activated)="deleteEvent()"
      [backgroundColor]="'var(--danger)'">Supprimer</frg-button>
    <frg-button (activated)="cancel()" [backgroundColor]="'var(--darkest-primary)'">Annuler</frg-button>
    <frg-button (activated)="saveEvent()">Sauvegarder</frg-button>
  </div>
</div>
